import { Dayjs } from 'dayjs'
import * as yup from 'yup'

import { EVENT_FORM_CONTEXT_IS_FINAL_SCRIPT_EVENT } from './formContext'
import { transcriptOrderFields } from './transcriptOrderFields'

import { DepositionResult, ReasonForCna } from '@/constants'

export const canceledEventSchema = yup.object().shape({
  result: yup
    .mixed<DepositionResult>()
    .oneOf(Object.values(DepositionResult))
    .required('Please select how deposition ended'),
  notes: yup.string().nullable().default(null),
  reason_for_cna: yup.mixed<ReasonForCna>().when('result', {
    is: (value: DepositionResult) => value === DepositionResult.CNA,
    then: schema =>
      schema
        .oneOf(Object.values(ReasonForCna), 'Please select reason for CNA')
        .required('Please select reason for CNA'),
    otherwise: schema => schema.nullable(),
  }),
  cna_declared_at: yup.mixed<Dayjs>().when('result', {
    is: (value: string) => value === DepositionResult.CNA,
    then: schema =>
      schema.required(
        'You must go on the record to declare CNA. Do that by clicking the ‘Go on record’ button.',
      ),
    otherwise: schema => schema.nullable(),
  }),
  last_timestamp: yup.mixed<Dayjs>().when('result', {
    is: (value: string) => value === DepositionResult.CNA,
    then: schema =>
      schema.required(
        'You must go on the record to declare CNA. Do that by clicking the ‘Go on record’ button.',
      ),
    otherwise: schema => schema.nullable(),
  }),
  other_reason: yup.string().when('reason_for_cna', {
    is: (value: string) => value === 'other',
    then: schema => schema.required('Please state other reason for CNA'),
    otherwise: schema => schema.nullable(),
  }),
  no_show_is_on_record: yup
    .boolean()
    .oneOf(
      [true],
      'You must go on the record. Do that by clicking the ‘Go on record’ button.',
    )
    .required(
      'You must go on the record. Do that by clicking the ‘Go on record’ button.',
    ),
  no_show_is_off_record: yup
    .boolean()
    .oneOf(
      [true],
      'You must go off the record. Do that by clicking the ‘Go off record’ button.',
    )
    .required(
      'You must go off the record. Do that by clicking the ‘Go off record’ button.',
    ),
  attendees_have_left_call: yup
    .boolean()
    .transform(val => val ?? false)
    .when(`$${EVENT_FORM_CONTEXT_IS_FINAL_SCRIPT_EVENT}`, {
      is: true,
      then: schema =>
        schema
          .oneOf([true], 'Please confirm all attendees have left the call.')
          .required('Please confirm all attendees have left the call.'),
      otherwise: schema => schema,
    }),
})

export const canceledClosingEventSchema = canceledEventSchema.concat(
  yup.object(transcriptOrderFields),
)
